module.exports = __webpack_public_path__ + "img/info_16_menu.3ea17614.png";